module.exports = __webpack_public_path__ + "img/clock-rorate-left.3c31afb1.svg";